import { MtBillingType } from "gen/clients/models/MtBillingType";
import { MtFileType } from "gen/clients/models/MtFileType";

/**
 * Price per word by rating. The key is the rating (1, 2, 3, 4, 5) and the value is the price per word.
 */
export type PriceByRating = {
  "1": number;
  "2": number;
  "3": number;
  "4": number;
  "5": number;
};

/**
 * Default values for PriceByRating
 */
export const DEFAULT_PRICE_BY_RATING: PriceByRating = {
  "1": 0,
  "2": 0,
  "3": 0,
  "4": 0,
  "5": 0
};

export function describeMtBillingType(type: MtBillingType): string {
  switch (type) {
    case MtBillingType.MONTHLY:
      return "Monthly Subscription";
    case MtBillingType.PER_WORD:
      return "Per-Word Usage";
    case MtBillingType.FREE_TRIAL:
      return "Free Trial";
    case MtBillingType.FREE:
      return "Free";
    case MtBillingType.MONTHLY_FLAT_RATE:
      return "Monthly Flat Rate";
    default:
      return "";
  }
}

export function describeMtFileType(type: MtFileType): string {
  switch (type) {
    case MtFileType.TEXT:
      return "Text (.txt)";
    case MtFileType.DELIMITED_TEXT:
      return "Delimited Text (.tsv, .csv)";
    case MtFileType.MARKUP:
      return "Markup (.html)";
    case MtFileType.LOCALIZATION:
      return "Localization (XLIFF 1.2, XLIFF 2.0)";
    case MtFileType.WORD:
      return "Word (.docx, .doc)";
    case MtFileType.EXCEL:
      return "Excel (.xlsx, .xls)";
    case MtFileType.POWERPOINT:
      return "PowerPoint (.pptx, .ppt)";
    case MtFileType.OPEN_DOCUMENT:
      return "Open Document (.odt, .ods, .odp)";
    case MtFileType.RICH_TEXT:
      return "Rich Text (.rtf)";
    case MtFileType.PDF:
      return "PDF (.pdf)";
    case MtFileType.IMAGE:
      return "Image (.png, .jpg, .jpeg, .gif, .svg, .tiff, .webp, .bmp)";
    case MtFileType.EMAIL:
      return "Email (.msg)";
    default:
      return "";
  }
}

export const allMtBillingTypeOptions = Object.keys(MtBillingType)
  .map(type => ({
    label: describeMtBillingType(type as MtBillingType),
    value: type
  }))
  .sort((o1, o2) => o1.label.localeCompare(o2.label));

export const mtBillingTypeOptionsForPreset = Object.keys(MtBillingType)
  .filter(type => type !== MtBillingType.FREE_TRIAL && type !== MtBillingType.MONTHLY)
  .map(type => ({
    label: describeMtBillingType(type as MtBillingType),
    value: type
  }))
  .sort((o1, o2) => o1.label.localeCompare(o2.label));

export const allMtFileTypeOptions = Object.keys(MtFileType)
  .map(type => ({
    label: describeMtFileType(type as MtFileType),
    value: type
  }))
  .sort((o1, o2) => o1.label.localeCompare(o2.label));
